export const CAMPAIGN_ITEM_SELECT_BROCHURE ='campaignItemSelectBrochure';
export const CAMPAIGN_ITEM_SELECT_SERVICES ='campaignItemSelectServices';
export const CAMPAIGN_ITEM_SELECT_COUPONS ='campaignItemSelectCoupons';
export const CAMPAIGN_ITEM_ADD_ADDRESSES ='campaignItemAddAddresses';
export const CAMPAIGN_ITEM_SELECT_BADGES ='campaignItemSelectBadges';